import mediaQuery from "@nodes/@material-ui/core/useMediaQuery";

export default function useMediaQuery(query) {
  const matches = mediaQuery(`(${query})`);
  return matches;
}
